import { Helmet } from "react-helmet-async";

interface Props {
  title: string;
  description?: string;
  image?: string;
  url?: string;
  type?: "website" | "article";
}

export function PageMeta({
  title,
  description,
  image,
  url,
  type = "website",
}: Props) {
  const siteName = "PropTRUST Navigator";
  const fullTitle = `${title} | ${siteName}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      {url && <meta property="og:url" content={url} />}
      <meta property="og:type" content={type} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
